export const lastUpdateDate = "16.10";
